import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bet-history',
  templateUrl: './bet-history.component.html',
  styleUrls: ['./bet-history.component.scss'],
})
export class BetHistoryComponent implements OnInit {
  title = 'app-bet-history';

  ngOnInit(): void {}
}
